import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Chapters {

  #rmp;
  #chapterDivs = [];
  #updateCurrentChapterFn = null;
  #chaptersArray = [];

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get array() {
    return this.#chaptersArray;
  }

  #seekToChapter(ms, event) {
    FW.eventStopPrevent(event);
    this.#rmp.seekTo(ms).catch(error => {
      this.#rmp.rmpUtils.warning(1016, error);
    });
    this.#rmp.rmpModuleManagement.close('chapters');
  }

  #updateCurrentChapter() {
    for (let i = 0, len = this.#chaptersArray.length; i < len; i++) {
      // check needed if content is shorter than chapters 
      if (this.#chapterDivs[i]) {
        this.#chapterDivs[i].classList.remove('rmp-overlay-level-active');
      }
    }
    const currentTime = this.#rmp.currentTime;
    if (currentTime >= 0) {
      for (let i = 0, len = this.#chaptersArray.length; i < len; i++) {
        const startMs = this.#chaptersArray[i].start;
        let chapter = this.#chapterDivs[len - 1];
        if (currentTime > this.#chaptersArray[len - 1].start) {
          chapter.classList.add('rmp-overlay-level-active');
          break;
        }
        if (currentTime >= startMs) {
          continue;
        }
        if (this.#chapterDivs[i - 1]) {
          chapter = this.#chapterDivs[i - 1];
          chapter.classList.add('rmp-overlay-level-active');
        }
        break;
      }
    }
  }

  #onLoadedmetadaAddChapters() {
    const duration = this.#rmp.duration;
    if (duration > 0 && this.#chaptersArray.length > 0) {
      this.#rmp.rmpModuleManagement.appendToModuleBar('chapters');
      this.#rmp.rmpModuleManagement.appendOverlay('chapters');
      this.#chapterDivs = [];
      const itemsToRemove = [];
      for (let i = 0, len = this.#chaptersArray.length; i < len; i++) {
        const startMs = this.#chaptersArray[i].start;
        // ignore chapter marks that are above content duration
        if (startMs >= duration) {
          itemsToRemove.push(i);
          continue;
        }
        let className = 'rmp-button rmp-overlay-level rmp-color-bg rmp-chapters-text';
        if (i === 0) {
          className += ' rmp-overlay-level-active';
        }
        this.#chapterDivs[i] = FW.createElement(
          'button',
          className,
          this.#chaptersArray[i].title,
          this.#rmp.rtl,
          true
        );
        this.#rmp.rmpAccessible.button(this.#chapterDivs[i], this.#chaptersArray[i].title, true);
        const seekToChapterFn = this.#seekToChapter.bind(this, startMs);
        FW.addEvents(['touchend', 'click'], this.#chapterDivs[i], seekToChapterFn);
        this.#rmp.dom.chaptersOverlayLevelsArea.appendChild(this.#chapterDivs[i]);
      }
      // remove chapter marks that are above content duration
      if (itemsToRemove.length > 0) {
        itemsToRemove.forEach(value => {
          this.#chaptersArray.splice(value, 1);
        });
      }
      this.#updateCurrentChapterFn = this.#updateCurrentChapter.bind(this);
      this.#rmp.on('timeupdate', this.#updateCurrentChapterFn);
    }
  }

  #parseChaptersVtt(data) {
    const lines = data.split(/(\r\n|\r|\n)/g);
    const re1 = /^\s*$/;
    const vttArray = [];
    lines.forEach(line => {
      if (!re1.test(line)) {
        vttArray.push(line);
      }
    });
    const re2 = /WEBVTT/i;
    if (!re2.test(vttArray[0])) {
      this.#rmp.rmpUtils.warning(15001);
      return;
    }
    vttArray.shift();

    const re3 = /^\s*\d*?:?\d*?:?\d+(\.\d+)?\s*-->\s*\d*?:?\d*?:?\d+(\.\d+)?\s*$/;
    for (let i = 0, len = vttArray.length; i < len; i++) {
      if (vttArray[i] && vttArray[i + 1] && re3.test(vttArray[i])) {
        const splitTime = (vttArray[i]).split('-->');
        const chapterTitle = vttArray[i + 1];
        if (splitTime.length === 2) {
          const start = (splitTime[0]).trim();
          const end = (splitTime[1]).trim();
          let startTime = start.replace(/\.\d+/i, '');
          if (/^00:/i.test(startTime) && startTime.length > 5) {
            startTime = startTime.replace(/^00:/i, '');
          }
          this.#chaptersArray.push({
            start: FW.dateToSeconds(start) * 1000,
            end: FW.dateToSeconds(end) * 1000,
            title: chapterTitle + ' - ' + startTime,
          });
        }
      }
    }
    Logger.print('chapters', 'parsed WEBVTT file', this.#chaptersArray);
    this.#rmp.dispatch('chaptersparsed');
    if (this.#rmp.hasLoadedMetadata) {
      this.#onLoadedmetadaAddChapters();
    } else {
      this.#rmp.one('loadedmetadata', this.#onLoadedmetadaAddChapters.bind(this));
    }
  }

  destroy() {
    this.#rmp.rmpModuleManagement.close('chapters', null);
    this.#rmp.rmpModuleManagement.destroy('chapters');
    this.#chaptersArray = [];
    this.#rmp.chaptersLoc = '';
  }

  init() {
    FW.ajax(this.#rmp.chaptersLoc, this.#rmp.ajaxWithCredentials, 'GET').
      then(data => {
        Logger.print('chapters', 'loaded VTT at URI ' + this.#rmp.chaptersLoc);
        this.#rmp.dispatch('chaptersloaded');
        if (typeof data === 'string') {
          this.#parseChaptersVtt(data);
        }
      }).catch(error => {
        this.#rmp.rmpUtils.warning(15000, error);
      });
  }

}
